// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"cafed943","273":"807043d6","598":"7a70620e"}[chunkId] + ".chunk.js";
};